module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content container-fluid page-dashboard"
  }, [(_vm.showMainCurrentState && _vm.showMonthlyPricingPlan) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-12 col-xs-12"
  }, [(_vm.showMainCurrentState) ? _c('main-current-state', {
    attrs: {
      "team": _vm.team,
      "forceFullWidthBoxes": true
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showMonthlyPricingPlan) ? _c('div', {
    staticClass: "col-lg-5 col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "page-header p-r-0"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("pricingPlan.title")) + "\n            "), (_vm.showPricingPlan2015) ? _c('a', {
    staticClass: "btn btn-link p-r-0 pull-xs-right",
    attrs: {
      "href": "https://www.byteark.com/pricing-2015",
      "target": "_blank"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("action.moreDetail"))), _c('i', {
    staticClass: "icon md-chevron-right m-r-0",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('a', {
    staticClass: "btn btn-link p-r-0 pull-xs-right",
    attrs: {
      "href": "https://www.byteark.com/pricing/",
      "target": "_blank"
    }
  }, [_vm._v("\n             " + _vm._s(_vm.$t("action.moreDetail"))), _c('i', {
    staticClass: "icon md-chevron-right m-r-0",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (_vm.showPricingPlan2015) ? _c('year-2015-pricing-plan') : _c('year-2017-pricing-plan')], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("mainHeaderGroups.solutions")))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('a', {
    staticClass: "non-link",
    attrs: {
      "href": _vm.serviceS3URL,
      "title": _vm.$t('solutions.fileDistributor.name'),
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "bg-white p-35 clearfix m-b-30 service-box file-distributor-box"
  }, [_c('div', {
    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
  }, [_c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number text-primary"
  }, [_vm._v(_vm._s(_vm.$t("solutions.fileDistributor.name")))])]), _vm._v(" "), _c('div', {
    staticClass: "counter-label font-size-14"
  }, [_c('p', {
    staticClass: "m-b-10 m-t-10"
  }, [_vm._v(_vm._s(_vm.$t("solutions.fileDistributor.shortDescription")))]), _vm._v(" "), _c('span', {
    staticClass: "blue-600"
  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.storage.name")) + "  "), _c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('a', {
    staticClass: "non-link",
    attrs: {
      "href": _vm.serviceQoderURL,
      "title": _vm.$t('solutions.vod.name'),
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "bg-white p-35 clearfix m-b-30 service-box vod-box"
  }, [_c('div', {
    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
  }, [_c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number text-primary"
  }, [_vm._v(_vm._s(_vm.$t("solutions.vod.name")))])]), _vm._v(" "), _c('div', {
    staticClass: "counter-label font-size-14"
  }, [_c('p', {
    staticClass: "m-b-10 m-t-10"
  }, [_vm._v(_vm._s(_vm.$t("solutions.vod.shortDescription")))]), _vm._v(" "), _c('span', {
    staticClass: "blue-600"
  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.qoder.name")) + " "), _c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('a', {
    staticClass: "non-link",
    attrs: {
      "href": _vm.serviceFleetURL,
      "title": _vm.$t('solutions.liveStraming.name'),
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "bg-white p-35 clearfix m-b-30 service-box"
  }, [_c('div', {
    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
  }, [_c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number text-primary"
  }, [_vm._v(_vm._s(_vm.$t("solutions.liveStraming.name")))])]), _vm._v(" "), _c('div', {
    staticClass: "counter-label font-size-14"
  }, [_c('p', {
    staticClass: "m-b-10 m-t-10"
  }, [_vm._v(_vm._s(_vm.$t("solutions.liveStraming.shortDescription")))]), _vm._v(" "), _c('span', {
    staticClass: "blue-600"
  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.fleet.name")) + " "), _c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('a', {
    staticClass: "non-link",
    attrs: {
      "href": _vm.serviceFleetURL,
      "title": _vm.$t('solutions.webCDN.name'),
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "bg-white p-35 clearfix m-b-30 service-box"
  }, [_c('div', {
    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
  }, [_c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number text-primary"
  }, [_vm._v(_vm._s(_vm.$t("solutions.webCDN.name")))])]), _vm._v(" "), _c('div', {
    staticClass: "counter-label font-size-14"
  }, [_c('p', {
    staticClass: "m-b-10 m-t-10"
  }, [_vm._v(_vm._s(_vm.$t("solutions.webCDN.shortDescription")))]), _vm._v(" "), _c('span', {
    staticClass: "blue-600"
  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.fleet.name")) + " "), _c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("mainHeaderGroups.quickStart")))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "list-group bg-white bg-inherit"
  }, [_c('a', {
    staticClass: "list-group-item text-primary",
    attrs: {
      "href": "http://docs.byteark.com/article/http-live-streaming/"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToLiveStream.name")) + "\n                "), _vm._m(4)]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item text-primary",
    attrs: {
      "href": "http://docs.byteark.com/article/getting-start/vod-streaming"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToUploadVdo.name")) + "\n                "), _vm._m(5)]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item text-primary",
    attrs: {
      "href": "http://docs.byteark.com/article/byteark-storage/"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToUploadFileToCDN.name")) + "\n                "), _vm._m(6)]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item text-primary",
    attrs: {
      "href": "http://docs.byteark.com/article/payment/"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToAddCredit.name")) + "\n                "), _vm._m(7)]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item text-primary",
    attrs: {
      "href": "http://docs.byteark.com/article/getting-start/web-cdn"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToImplementCDN.name")) + "\n                "), _vm._m(8)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-xs-right white m-t-10"
  }, [_c('i', {
    staticClass: "icon icon-circle icon-2x md-storage bg-primary"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-xs-right white m-t-10"
  }, [_c('i', {
    staticClass: "icon icon-circle icon-2x md-videocam bg-primary"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-xs-right white m-t-10"
  }, [_c('i', {
    staticClass: "icon icon-circle icon-2x md-swap-vertical bg-primary"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-xs-right white m-t-10"
  }, [_c('i', {
    staticClass: "icon icon-circle icon-2x md-laptop bg-primary"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-xs-right"
  }, [_c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-xs-right"
  }, [_c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-xs-right"
  }, [_c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-xs-right"
  }, [_c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-xs-right"
  }, [_c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2829aaf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 520
// module chunks = 1